import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
// import {Settings, Menu} from '@material-ui/icons';

export default class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            admin_menu_open: false,
            
        }
    }

    render() {
        return (
            <div>
                <Grid>
                    Welcome to the AutoZone TMS
                </Grid>
            </div>
        );
    }
}